const translations = {
    allData: 'All Data',
    applications: 'Applications',
    assets: 'Assets',
    boundaries: 'Boundaries',
    clients: 'Clients',
    farms: 'Farms',
    fields: 'Fields',

    reports: 'Reports',
    users: 'Users'
};

export default translations;
